/* eslint-disable react-hooks/exhaustive-deps */
import WrapUpPageComponent from '../component/WrapUpPageComponent';
import WrapUpPageList from '../component/WrapUpPageList';
import NextPatientButton from '../component/NextPatientButton';
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { summaryView } from '../services/solevaniaService';
import { useUpdateReviewStatus } from '../hooks/useUpdateReview';
import EastIcon from '@mui/icons-material/East';
import WestIcon from '@mui/icons-material/West';

export default function WrapUpPage({ setActiveStep }) {
  const navigate = useNavigate();
  const { state } = useLocation();
  const hasFetchedSummary = useRef(false);
  const [summaryData, setSummaryData] = useState(null);
  const [anamnezaValue, setAnamnezaValue] = useState('');
  const [klinicniStatus, setKlinicniStatus] = useState('');
  const [Plan, setPlan] = useState('');
  const updateReviewMutation = useUpdateReviewStatus();
  const handleMarkAsReviewed = (recordingId) => {
    updateReviewMutation.mutate({
      recordingId: recordingId,
      isReviewed: true,
    });
  };

  const handleSummaryView = async (id) => {
    const payload = {
      recording_id: id,
    };

    try {
      const response = await summaryView(payload);

      if (response?.data?.status) {
        setSummaryData(response?.data?.data);
      }
    } catch (error) {
      console.error('Error happened while submit recording', error);
    }
  };

  useEffect(() => {
    setActiveStep(3);
  }, []);

  useEffect(() => {
    if (!state?.recordingId) return;
    if (hasFetchedSummary.current) return;

    setActiveStep(2);
    handleSummaryView(state?.recordingId);
    hasFetchedSummary.current = true;
  }, [state?.recordingId]);

  useEffect(() => {
    if (summaryData?.summaries) {
      setAnamnezaValue(summaryData?.summaries?.anamneza);
      setKlinicniStatus(summaryData?.summaries?.klinicni_status);
      setPlan(summaryData?.summaries?.plan);
    }
  }, [summaryData]);

  return (
    <div className="flex h-full flex-col">
      <div className="flex-1">
        <div className="flex flex-col p-2 sm:p-4 gap-4">
          <WrapUpPageComponent
            text={anamnezaValue}
            heading={"Medical History"}
          />

          <WrapUpPageComponent
            text={klinicniStatus}
            heading={"Clinical Status"}
          />

          <WrapUpPageList
            heading="Diagnosis"
            listitem={summaryData?.summaries?.icd_codes}
          />
          <WrapUpPageComponent text={Plan} heading={"Plan"} />
          <WrapUpPageList
            heading="Service Codes"
            listitem={summaryData?.summaries?.sifra_codes}
          />
        </div>
      </div>

      <div className="flex justify-between w-full">
        <button
          onClick={() => navigate(-1)}
          className="p-3 bg-[#B4B4B4] text-[#015A52] rounded-full cursor-pointer"
        >
          <WestIcon />
        </button>

        <NextPatientButton
          onClick={() => handleMarkAsReviewed(state?.recordingId)}
        />
      </div>
    </div>
  );
}
